// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ShopIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ShopIcon" ref={forwardedRef} {...props}>
      <path d="M1 3.25h2.201a.25.25 0 0 1 .243.194l.568 2.464 1.366 6.842h11.146L19 5H5.34L4.904 3.107A1.75 1.75 0 0 0 3.2 1.75H1z" />
      <path d="M8.988 16c0 1.105-.894 2-1.997 2a2 2 0 0 1-1.997-2c0-1.105.894-2 1.997-2a2 2 0 0 1 1.997 2" />
      <path d="M14.727 18a2 2 0 0 0 1.997-2c0-1.105-.894-2-1.997-2a2 2 0 0 0-1.997 2c0 1.105.894 2 1.997 2" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const ShopIcon = /* @__PURE__ */ Object.assign(ShopIconComponent, {
  displayName: 'ShopIcon',
});
